export const ADD_PENDING_PAGE = "ADD_PENDING_PAGES";
export const GET_PENDING_PAGES = "GET_PENDING_PAGES";
export const GET_NON_PUBLISHED_PAGES = "GET_NON_PUBLISHED_PAGES";
export const GET_PUBLISHED_PAGES = "GET_PUBLISHED_PAGES";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const PUBLISH = "PUBLISH";
export const DELETE = "DELETE";
